const GRID_SELECTOR = '.js-grid';
const PRODUCT_CLASS = 'js-grid-product';
const BANNER_SELECTOR = '.js-grid-banner';

var bannerMedia = window.matchMedia('(max-width: 576px)');
keepGridCorrectByBannerResize(bannerMedia);

bannerMedia.addListener(keepGridCorrectByBannerResize);

function keepGridCorrectByBannerResize(media) {
    var banners = document.querySelectorAll(BANNER_SELECTOR);

    banners.forEach(banner => {
        if (media.matches) normalizeGrid(banner);
    });
}

function normalizeGrid(banner) {
    var prevProducts = getAllPrevProductsUntilStartOrOtherBanner(banner);

    if (isOddNumProducts(prevProducts)) {
        movePrevProductToNextOfBanner(banner);
    }
}

function getAllPrevProductsUntilStartOrOtherBanner(banner) {
    var productsStorage = [];
    var prevSibling = banner.previousElementSibling;

    while (prevSibling && prevSibling.classList.contains(PRODUCT_CLASS)) {
        productsStorage.push(prevSibling);
        prevSibling = prevSibling.previousElementSibling;
    }

    return productsStorage;
}

function isOddNumProducts(products) {
    return products.length % 2 != 0;
}

function isEvenNumProducts(products) {
    return !isOddNumProducts(products);
}

function movePrevProductToNextOfBanner(banner) {
    var prevProduct = banner.previousElementSibling;
    var nextBannerSibling = banner.nextElementSibling;
    var bannerParent = banner.parentNode;

    if (prevProduct && prevProduct.classList.contains(PRODUCT_CLASS)) {
        bannerParent.removeChild(prevProduct);

        if (nextBannerSibling) bannerParent.insertBefore(prevProduct, nextBannerSibling);
        else bannerParent.appendChild(prevProduct);
    }
}